

<app-navbar></app-navbar>

<div class="sales-leadership">
    <div class="left">
        <app-brochure-button
         fileName="Sales Leadership certification.pdf"
         label="Download Brochure"
         className="outline-btn">
      </app-brochure-button>

        <h1> SALES LEADERSHIP</h1>
        <h1> COACHING CERTIFICATION</h1>

        <h2> WHY CHOOSE <br> NexGen Executive Coaching Academy?</h2>

        <h5>FLEXIBILITY</h5>
        <p>Start and complete your training at your own pace</p>

        <h5> PRACTICAL APPROACH:</h5>
        <p>Learn from experienced Fortune 500 business professionals</p>

        <h5> IN-DEPTH MODERN CONTENT:</h5>
        <p>Comprehensive training including AI Coaching, neuroscience, advanced coaching frameworks,
            cultural intelligence, cognitive behavioral techniques, and emotional intelligence</p>

    </div>

    <div class="right">
        <div class="image">
            <img src="../../../assets/salesCertification/Screenshot 2025-07-23 010203.png" alt="">
        </div>
        <div class="contant">
            <div class="contant1">
                <h1>PROGRAM OVERVIEW</h1>
                <p> This specialty certification equips executive coaches
                    with the tools to help <span>sales leaders</span> drive <span>revenue
                        growth, build high-performing teams, and implement
                        effective sales methodologies</span> across organizations.</p>
            </div>
            <div class="contant2">
                <h5>nexgencoaches.com</h5>
                <h1> NexGen Executive Coaching Academy</h1>
                <p> Copyright NexGen Executive Coaching Academy, L.L.C. All rights reserved, not for duplication or
                    re-use</p>
            </div>
        </div>
    </div>
</div> 

<div class="main2">
  <div class="left">
    <h2>WHAT YOU’LL LEARN</h2>
    <img src="../../../assets/salesCertification/2.png" alt="Learning 1">
    <img src="../../../assets/salesCertification/3.png" alt="Learning 2">
  </div>

  <div class="middle">
    <p>Program Cost: $995</p>
    <h2>SALES LEADERSHIP</h2>
    <p>NEXGEN EXECUTIVE COACHING ACADEMY SPECIALTY CERTIFICATION</p>

    <ul>
      <li>
        1-Day Live Virtual Intensive Seminar (Saturday or Sunday)
      </li>
      <li>
        Total Training: 10 hours
        <ul>
          <li>8 hours live sessions by sales leadership experts</li>
          <li>2 hours AI-driven, technologically advanced LMS platform</li>
          <li>Competency exam to receive the Sales Leadership Certification</li>
        </ul>
      </li>
    </ul>

    <p class="elite">Elite Science-Based Coaching Frameworks for Sales Leaders</p>
    <p class="become">
      “Become certified as NexGen Executive Coaching Academy Sales Executive Coach and help Sales Leaders improve their teams performance and increase Sales by 20%”
    </p>
    <p class="source">
      Source: Dimensions of effective sales coaching: scale development and validation
    </p>

    <h5 class="prerequisits-title">PREREQUISITES</h5>
    <ul class="prerequisits">
      <li>Current enrollment in NexGen Executive Coaching Academy Platinum or Gold Program, OR</li>
      <li>Existing NexGen Executive Coaching Certification from an accredited program, OR</li>
      <li>ICF Certification</li>
    </ul>

    <p class="copyright">
      © NexGen Executive Coaching Academy, L.L.C. All rights reserved, not for duplication or re-use
    </p>
    <p class="bottom">nexgencoaches.com</p>
  </div>

  <div class="right">
    <img src="../../../assets/salesCertification/4.png" alt="Certification">
  </div>
</div>


<app-footer></app-footer>